<section class="teaser-slides bg-section block no-overflow margin--bottom-l margin--top-l">
  <div class="relative js-slider">
    <swiper *ngIf="swiperConfig" [config]="swiperConfig">
      <ng-template swiperSlide *ngFor="let slide of data.teaser">
        <div class="default-padding width-100">
          <div class="default-max-width centered">
            <article class="teaser-slide-item">
              <header class="teaser-slide-item-header">
                <h1 class="headline-first">{{ slide.title }}</h1>

                <div class="teaser-slide-item-push tablet-hidden">
                  <a href="{{ slide.teaser.link }}" class="btn btn--outline">
                    {{ slide.teaser.button }}
                  </a>
                </div>
              </header>

              <div class="teaser-slide-item-main default-font-sizes default-font-sizes--big">
                <p>
                  {{ slide.teaser.teaserText }}
                </p>

                <div class="tablet-show">
                  <a href="{{ slide.teaser.link }}" class="btn btn--outline">
                    {{ slide.teaser.button }}
                  </a>
                </div>
              </div>

              <footer class="teaser-slide-item-footer">
                <img *ngIf="slide.teaser.image" [src]="slide.teaser.image.formats?.small?.url || slide.teaser.image.url" alt="" />
              </footer>
            </article>
          </div>
        </div>
      </ng-template>
    </swiper>

    <div class="swiper-arrow swiper-arrow--prev swiper-arrow--prev-{{ data.id }}">
      <i class="icon-arrow-6"></i>
    </div>

    <div class="swiper-arrow swiper-arrow--next swiper-arrow--next-{{ data.id }}">
      <i class="icon-arrow-6"></i>
    </div>

    <div class="swiper-pagination swiper-pagination-{{ data.id }} swiper-pagination--on-bg"></div>
  </div>
</section>
